import { render, staticRenderFns } from "./lotteryType.vue?vue&type=template&id=2b0a06d2&scoped=true"
import script from "./lotteryType.vue?vue&type=script&lang=js"
export * from "./lotteryType.vue?vue&type=script&lang=js"
import style0 from "./lotteryType.vue?vue&type=style&index=0&id=2b0a06d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a06d2",
  null
  
)

export default component.exports